export default {
	activity_appointment: 'Termin',
	activity_dataset: 'Akte',
	activity_document: 'Dokument',
	activity_mail: 'E-Mail',
	activity_message: 'Nachricht',
	activity_note: 'Merkzettel',
	activity_phonecall: 'Anruf',
	activity_scheduled_activity: 'Aktennotiz',
	activity_task: 'Aufgabe',
};
